import React, { useEffect, useState } from 'react';
import { Button, Dialog, SearchInput } from "evergreen-ui";
import FireFetch from "../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { DatePicker, Table } from "antd";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import moment from "moment";


var db = getDatabase(Firebase);
const { RangePicker } = DatePicker;
const Points = () => {
	const columns = [
		{
			title: 'Key',
			dataIndex: 'key',
			key: 'key',
			sorter: (a, b) => a.key && a.key.localeCompare(b.key)
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			responsive: ["sm"],
			sorter: (a, b) => a.name && a.name.localeCompare(b.name)
		},
		{
			title: 'Quizzes Done',
			dataIndex: 'quizzes',
			key: 'quizzes',
			sorter: (a, b) => parseFloat(b.quizzes) - parseFloat(a.quizzes)
		},
		{
			title: 'Lessons Done',
			dataIndex: 'lessons',
			key: 'lessons',
			responsive: ["sm"],
			sorter: (a, b) => parseFloat(b.lessons) - parseFloat(a.lessons)
		},
		{
			title: 'Interactions Done',
			dataIndex: 'interactions',
			key: 'interactions',
			sorter: (a, b) => parseFloat(b.interactions) - parseFloat(a.interactions)
		},
		{
			title: 'Activities Done',
			dataIndex: 'activities',
			key: 'activities',
			sorter: (a, b) => parseFloat(b.activities) - parseFloat(a.activities)
		},

		{
			title: 'Overall Points',
			dataIndex: 'points',
			key: 'points',
			sorter: (a, b) => parseFloat(b.points) - parseFloat(a.points)
		}
	];
	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([]);
	const [points, loading] = useListVals(ref(db, "talmidsdb/points"));
	const [pointArray, setPointArray] = useState([]);
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [showPicker, setShowPicker] = useState(false);
	const [period, setPeriod] = useState([]);

	function getSum(total, num) {
		return (total + parseInt(num.amount));
	}

	useEffect(() => {
		if (points) {
			setPointArray(points);
			process(pointArray);
		}
	}, [pointArray, points, userArray]);

	const process = (forArray) => {
		// get the grades of the known users first : those whose IDs are in the system
		var tempArray = []
		userArray.map((user, index) => {
			var gradesForUser = forArray.filter(x => x.id === user.userID);

			if (gradesForUser.length > 0) {
				tempArray.push({
					key: index + 1,
					name: user.firstname + " " + user.surname,
					quizzes: gradesForUser.filter(x => x.earnedfrom === "Quiz").length,
					lessons: gradesForUser.filter(x => x.earnedfrom === "Lesson").length,
					interactions: gradesForUser.filter(x => x.earnedfrom === "Interaction").length,
					points: (gradesForUser.reduce(getSum, 0)),
					activities: gradesForUser.filter(x => x.earnedfrom === "Activity").length,
				});
			}
		});

		//And then filter out userIDs which are not in the system for some strange reason
		var unknownArray = [];
		forArray.map((grade) => {
			if ((userArray.find(x => x.id === grade.userID) === undefined)) {
				unknownArray.push(grade);
			}
		});

		//Group the unknown grades based on different userIDs that have been found into one object under a userID key
		//and the array of the unknown user's grades is the value
		var unknownObject = {}
		unknownArray.map((item) => {
			unknownObject[item.userID] = unknownArray.filter(x => x.id === item.userID);
		});

		//add these grouped unknown users into the tempArray to paste to the table, under the alias of unknown user plus index
		//given the fact that they have different IDs
		Object.values(unknownObject).map((value, index) => {
			tempArray.push({
				key: index + 1,
				grade: ((value.reduce(getSum, 0)) / (value.length)).toFixed(1),
				name: "Unknown User " + (index + 1),
				quizzes: value.length
			});
		});

		//The keys are way off at this point, for each object in the tempArray (coz we were pushing at different points
		// in the execution of the grouping etc). So simply just assign the key to the index in the new array
		tempArray.map((value, index) => {
			value.key = index + 1;
		});

		//send it to the table state value.
		setEventsData([...tempArray]);
		setDataArray([...tempArray]);
	}

	function exportXL(tab) {
		var table = tab;
		var exportData = table.getExportData();
		console.log(exportData);
		var csv = exportData?.rankingTable?.csv;
		table.export2file(csv?.data, csv?.mimeType, csv?.filename, csv?.fileExtension, csv?.merges, csv?.RTL, csv?.sheetname);

	}

	const handleSearch = searchText => {
		searchText = searchText.toLowerCase();
		const filteredEvents = dataArray.filter(({ name, time }) => {
			name = name && name.toLowerCase();
			time = time && time.toLowerCase();
			return (name && name.includes(searchText)) || (time && time.includes(searchText));
		});

		setEventsData(filteredEvents);
	};
	function onDateChange(date, dateString) {
		setPeriod(dateString);
	}

	function filterPeriod() {

		var startTime = moment(period[0], 'YYYY-MM-DD');
		var endTime = moment(period[1], 'YYYY-MM-DD');

		var withinPeriodArray = [];
		pointArray.map((inter) => {
			var interTime = moment(inter.timestamp, "YYYY-MM-DDTh:mm:ss");
			if (moment(interTime).isBetween(startTime, endTime)) {
				withinPeriodArray.push(inter);
			}
		});
		process(withinPeriodArray);
		setShowPicker(false)
	}

	return (
		<>
			<div>
				<Dialog
					isShown={showPicker}
					title="Select Period"
					onCloseComplete={() => { setShowPicker(false) }}
					onConfirm={() => {
						filterPeriod();
					}}
				>
					<RangePicker style={{ width: "100%" }} onChange={onDateChange} />
				</Dialog>
				<div style={{ marginBottom: 10 }} className="float-right">
					<SearchInput placeholder="Search Users" className="w-100 mx-1" width={window.innerWidth - 1000} onChange={e => handleSearch(e.target.value)} />
					<Button appearance="primary" className="mx-1" onClick={() => {
						setShowPicker(true);
					}}>
						Filter Period
					</Button>
					<Button appearance="primary" className="mx-1" onClick={() => {
						exportXL(TableExport(document.getElementById("pointsTable"), {
							filename: "Points",
							exportButtons: false,
							sheetname: "Points",
						}));
					}}>
						Print
					</Button>
				</div>
				<Table style={{ overflow: "auto" }} loading={loading}
					pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
					id={"pointsTable"} dataSource={eventsData} columns={columns} />
			</div>
		</>
	)
}

export default Points;
